const {
  handleSelectedVariantAvailability,
  handleFormInputs
} = await import(`./component-product.js?v=${Date.now()}`);
import "./recommended-products.js";
import addButton from "./component-add-button-state.js?v=1";
const { shopifyCart } = await import(`./shopify-cart.js?v=${Date.now()}`);
import "./pricing.js";
import "./type-check.js";
import "./index.js";
import "./_commonjsHelpers.js";
import "./get-sections.js";
import "./component-cart-state.js";
import "./component-cart-drawer-state.js";
import "./body-lock.js";
import "./html2canvas.esm.js";

class ProductForm extends HTMLElement {
  constructor() {
    super();
    let form = this.querySelector("form");
    let addToCartButton = this.querySelector("#addToBagButton");
    let handleAddToCart = async (event) => {
      let formData = Object.fromEntries(new FormData(event.target).entries());
      let setProductData = this.querySelectorAll(".set-product-data");
      if (formData.productVariant && form.checkValidity() && setProductData.length >= 1) {
        await shopifyCart.addSetProduct(formData, addToCartButton, setProductData);
      } else if (formData.productVariant && form.checkValidity()) {
        await shopifyCart.add(formData, addToCartButton);
      } else {
        addButton.setMakeSelection();
      }
    };
    if (form) {
      if (!addToCartButton.classList.contains("preorder")) {
        handleSelectedVariantAvailability();
      }
      handleFormInputs(form);

      form.addEventListener("submit", (event) => {
        event.preventDefault();
        handleAddToCart(event);
      });
    }
  }
}
if (customElements.get("product-form") === void 0) {
  customElements.define("product-form", ProductForm);
}
